// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__WNET2","title":"Images90_title__2tHda","images":"Images90_images__1romk"};